import {getCookie, eraseCookie} from "@/store/util/cookieUtils";
import Vue from 'vue';

const state = {
	status: '',
	token: '',
	user: null,
	myCenters: null,
}

const mutations = {
	auth_request(state) {
		state.status = 'loading'
	},
	auth_success(state, payload) {
		state.status = 'success'
		state.token = payload.token
		state.user = payload.user
	},
	auth_error(state) {
		state.status = 'error'
	},
	auth_logout(state) {
		state.status = ''
		state.token = ''
		state.user = null
		state.myCenters = null
	},
	my_centers(state, centers){
		state.myCenters = centers
	}
}

const actions = {
	setMyCenters({ commit }, centers) {
		commit('my_centers', centers);
	},
	updateUserToken({ commit }, obj) {
		// const cookieName = 'JWT-TOKEN';
		const vm = obj.vm;
		const token = obj.auth.token;
		const user = obj.auth.user;

		if(process.env.NODE_ENV == 'development'){
			localStorage.setItem("token", token);
			vm.$axios.defaults.headers.common["Authorization" ] = `Bearer ${token}`;
		}

		commit({
			type: 'auth_success',
			token: token,
			user: user
		});
	},
	processLogout( {commit} ) {
		const cookieName = 'JWT-TOKEN';

		//Check if JWT Token is already in cookie, if not, manually set (could be cross domain)
		const jwt = getCookie(cookieName);
		if(jwt){
			eraseCookie(cookieName)
		}

		//remove token from localstorage
		localStorage.removeItem('token')

		commit('auth_logout')
	},
	async remoteJwtTokenCheck( {commit} ){
		// console.log('initiating jwt token check')
		return await Vue.axios.get('/jwt-token-check')
			.then( (resp ) => {
				if(resp.data){
					const token = resp.data.jwttoken;
					const user = {
						email: resp.data.email,
						firstName: resp.data.firstName,
						lastName: resp.data.lastName,
						company: resp.data.companyName,
						gsuiteAPIAvailable: resp.data.gsuiteAPIAvailable,
						uId: resp.data.uid,
						confirmed: resp.data.confirmed,
						roles: resp.data.roles,
						modules: resp.data.modules
					}
					
					commit({
						type: 'auth_success',
						token: token,
						user: user
					});
				}
				else{
					console.warn('No valid jwt token found');
				}
			} )
			.catch( (error) => {
				console.error('failed jwt token check', error);
				throw 'Fail JWT token validation';
			})
	}
}

const getters = {
	isLoggedIn: state => state.user != null,
	authStatus: state => state.status,
	currentUser: (state) => {
		return state.user
	},
	myCenters: (state) => {
		return state.myCenters
	},
	isAdministrator: (state) => {
		return state.user && Array.isArray(state.user.roles) &&  state.user.roles.indexOf('ADMIN') > -1;
	},
	userRoles: (state) => {
		return state.user ? state.user.roles:null;
	},
	userModules: (state) => {
		return state.user ? state.user.modules:null;
	},
}

export default {
	state,
	mutations,
	actions,
	getters
}
